module.exports = __webpack_public_path__ + "img/milk.0a0237ab.jpg";